export class ApiResponseError extends Error {
  constructor(operation: string) {
    super(`API response for ${operation} returned no data.`);
    this.name = 'ApiResponseError';
  }
}